import { render, staticRenderFns } from "./certiticateChangeLogList.vue?vue&type=template&id=3c1202d4&scoped=true&"
import script from "./certiticateChangeLogList.vue?vue&type=script&lang=js&"
export * from "./certiticateChangeLogList.vue?vue&type=script&lang=js&"
import style0 from "./certiticateChangeLogList.vue?vue&type=style&index=0&id=3c1202d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1202d4",
  null
  
)

export default component.exports